<template>
  <!-- eslint-disable vue/no-unused-refs -->
  <AppBarLayout>
    <template #default="{ activeHierarchy }">
      <div class="main tw-overflow-x-hidden">
        <BrandPattern4 ref="animation" page="APPBARLAYOUT" />
        <backgroundComponent ref="backgroundRef" />
        <ActivePathWrapper :active-hierarchy="activeHierarchy" />
        <div class="xl:tw-px-[60px] tw-py-[55px] tw-px-[10px] tw-bg-white">
          <p class="title-inner">
            <span class="tw-text-[#211F58] tw-font-semibold">{{
              getUiText("app-settings-team-roles-manage-roles-title-1")
            }}</span>
          </p>

          <NoteInfo
            v-if="notInfoVisible"
            class="custom-info tw-mt-[20px]"
            @close="() => (notInfoVisible = false)"
          >
            <span class="tw-text-[#211F58] tw-text-[15px]">{{
              getUiText("app-settings-team-roles-tip-top-text-1")
            }}</span>
            <!--            <a href="#" class="tw-underline tw-text-[#387DFF] tw-text-[15px]">{{ -->
            <!--              getUiText("app-settings-team-members-tip-top-link-text-1") -->
            <!--            }}</a> -->
          </NoteInfo>
        </div>
        <div
          class="tw-py-[40px] xl:tw-py-[55px] xl:tw-px-[60px] tw-px-[10px] roles-container tw-flex tw-gap-[40px]"
        >
          <!-- Current roles -->
          <div
            class="tw-flex-col-reverse xl:tw-flex-row content tw-flex-1 tw-max-w-[1182px]"
          >
            <div id="clickbox-role" class="table-content">
              <div class="current-roles-container tw-flex">
                <div class="current-roles-table">
                  <!-- Header -->
                  <div
                    class="table-header tw-flex tw-items-center tw-justify-between tw-mb-5"
                  >
                    <span
                      class="tw-text-[#211F58] tw-text-[18px] tw-font-semibold"
                      >{{
                        getUiText(
                          "app-settings-team-roles-manage-roles-subtitle-1",
                        )
                      }}</span
                    >
                  </div>
                  <!-- Role skeleton -->
                  <div v-if="loading">
                    <div
                      v-for="item in [0, 1, 2]"
                      :key="item"
                      class="list-container tw-mb-5"
                    >
                      <div
                        class="sub-header tw-flex tw-items-center tw-px-[15px] md:tw-px-[25px] tw-py-[20px] sub-header-container"
                      >
                        <div
                          class="tw-h-[28px] tw-w-[155px] custom-global-skeleton-pulse"
                        ></div>
                      </div>
                      <div
                        class="list-content tw-text-sm tw-py-[10px] md:tw-py-10 tw-px-[20px] md:tw-px-10 tw-flex tw-flex-col tw-gap-[25px]"
                      >
                        <div
                          class="tw-h-[28px] tw-w-[195px] custom-global-skeleton-pulse"
                        ></div>

                        <div
                          class="tw-h-[76px] tw-w-[100%] tw-rounded-md custom-global-skeleton-pulse"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <!-- Master of the universe -->
                  <div v-else>
                    <div
                      v-for="(role, index) in roles"
                      :key="role['roleId']"
                      class="list-container tw-mb-5"
                    >
                      <div
                        class="sub-header tw-flex tw-items-center tw-px-[15px] md:tw-px-[25px] tw-py-[20px]"
                      >
                        <!-- TODO: TEMPORARY -->
                        <span
                          class="tw-text-[#211F58] tw-text-[18px] tw-font-semibold tw-flex-1"
                          data-cy="role-management-role-name"
                          >{{ role["roleName"] }}</span
                        >
                        <ButtonShowMore
                          classes="!tw-p-[0px]"
                          :id-popover="
                            'popover-btn-show-more-roles-managemnet-' + index
                          "
                          data-cy-id="role-management-show-more-button"
                        >
                          <template #default>
                            <CustomDropDownItem
                              :style="'normal'"
                              data-cy="role-management-button-show-more"
                              :id-text="'app-settings-team-roles-more-modal-manage-role-1'"
                              @click="goToManageRole(role['roleId'])"
                            />
                            <CustomDropDownItem
                              v-if="memberOfRoles[role['roleId']]?.length === 0"
                              :style="'danger'"
                              :id-text="'app-settings-team-roles-more-modal-delete-role-1'"
                              @click="showDeleteModal(role['roleId'])"
                            />
                          </template>
                        </ButtonShowMore>
                      </div>
                      <div
                        class="list-content tw-text-sm tw-py-[10px] md:tw-py-10 tw-px-[20px] md:tw-px-10 tw-flex tw-flex-col tw-gap-[25px]"
                      >
                        <!-- TODO: TEMPORARY -->
                        <span>
                          <span class="tw-font-medium">{{
                            getUiText(
                              "app-settings-team-roles-heading-privilege-level-1",
                            )
                          }}</span
                          >&nbsp;
                          <span class="grey-color">{{
                            role["permissionLevel"]
                          }}</span>
                        </span>
                        <div>
                          <span class="tw-font-medium"
                            >{{
                              getUiText(
                                "app-settings-team-roles-manage-role-form-label-mfa-required-1",
                              )
                            }}:</span
                          >&nbsp;
                          <span class="grey-color">{{
                            role["roleRequiresMFA"]
                              ? getUiText(
                                  "app-menu-submenu-home-setup-wizard-radio-button-title-yes-1",
                                )
                              : getUiText(
                                  "app-menu-submenu-home-setup-wizard-radio-button-title-no-1",
                                )
                          }}</span>
                        </div>
                        <div class="content tw-flex tw-flex-col">
                          <div
                            v-if="
                              role['roleId'] && memberOfRoles[role['roleId']]
                            "
                            class="card-container"
                          >
                            <CardRolesSetting
                              v-for="data in memberOfRoles[role['roleId']]"
                              :key="data"
                              :data="data"
                            />
                          </div>
                        </div>
                        <div class="tw-flex tw-justify-end">
                          <Button1
                            class="button-add"
                            data-cy="role-management-add-user-to-role-button"
                            :disabled="false"
                            :title="
                              getUiText(
                                'app-settings-team-roles-add-user-button-1',
                              )
                            "
                            @click="showModalAddUserToRole(role)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="tw-max-w-[241px] tw-order-[1] md:tw-order-[2] tw-w-[100%] tw-flex tw-justify-center tw-rounded-br-md tw-rounded-bl-md tw-h-[fit-content]"
          >
            <ActionButton
              :profile-actions="actions"
              class="md:tw-min-w-[241px]"
            />
          </div>
        </div>
        <ManageUserModal
          :show="showModalDeleteRole"
          :header="true"
          :red-btn="true"
          header-title="app-settings-team-members-profile-modal-delete-action-warning-1"
          contain-title="app-settings-team-roles-manage-role-delete-role-action-title-1"
          contain-sub-title="app-settings-team-roles-manage-role-delete-role-action-helper-a-1"
          action-title="app-settings-team-roles-manage-role-delete-role-action-title-1"
          @update:show="showModalDeleteRole = $event"
          @update:action-handle="onDeleteRole"
        />

        <!-- Modal: Add role -->
        <AddRoleModal
          :show="showModalAddRole"
          @update:show="showModalAddRole = $event"
        />

        <AddUserRoleModal
          :show="showModalAddUser"
          :role-id="selectedRole"
          :role-name="selectedRoleName"
          @update:show="showModalAddUser = $event"
          @add:user-to-role="handleAddUserToRole"
        />
      </div>
    </template>
  </AppBarLayout>
</template>

<script lang="ts" setup>
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import CardRolesSetting from "@/components/common/setting/cardRolesSetting.vue";
import ButtonShowMore from "@/components/common/setting/buttonShowMore.vue";
import { Ref, computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import store from "@/store";
import router from "@/router";
import utilities, { getComponentUiText } from "@/utils/utilities";
import ActionButton, { Action } from "@/components/common/actionButton.vue";
import NoteInfo from "@/components/common/noteInfo.vue";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import backgroundComponent from "@/components/common/backgroundComponent.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import AddRoleModal from "@/components/team/roles/addRoleModal.vue";
import PlusWrappedIcon from "@/components/svgs/plusWrappedIcon.vue";
import UserIcon from "@/components/svgs/userIcon.vue";
import Button1 from "@/components/common/button1.vue";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import AddUserRoleModal from "@/components/team/roles/addUserRoleModal.vue";
import { getMemberOfRoles, deleteRole } from "@/services/org";
import { IOrgRole } from "@/interfaces/org/role";
import { IOrgMemberRes } from "@/interfaces/org/role";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import uniqBy from "lodash/uniqBy";
import ManageUserModal from "@/components/orgManagement/manageUserModal.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { routers } from "@/utils/constants";

const showModalAddRole: Ref<boolean> = ref(false);
const showModalAddUser: Ref<boolean> = ref(false);
const roles: Ref<IOrgRole[]> = computed(
  () => store.getters["Org/getOrgRolesData"],
);
const memberOfRoles: Ref<any> = ref({});
const loading: Ref<boolean> = ref(true);
const selectedRole: Ref = ref("");
const selectedRoleName: Ref = ref("");
const backgroundRef = ref(null);
const notInfoVisible = ref(true);
let showModalDeleteRole = ref(false);
const actions: Action[] = [
  {
    icon: PlusWrappedIcon,
    iconColor: "#211F58",
    title: "app-settings-team-roles-actions-menu-add-role-1",
    titleClass: "tw-w-full",
    onClick: () => addRole(),
  },
  {
    icon: UserIcon,
    iconColor: "#211F58",
    title: "app-settings-team-roles-actions-menu-manage-team-1",
    titleClass: "tw-w-full",
    onClick: () => router.push({ path: routers.settingTeamMembers }),
  },
];
const isLoading = computed(() => store.state.Org.isLoadingOrg);
const currentOrg = computed(() => store.state.Org.currentOrg);
const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

watch(currentOrg, async (oldValue: any, newValue: any) => {
  if (newValue.id && oldValue.id && newValue.id !== oldValue.id) {
    store.dispatch("Org/fetchGrantedOrgsList");
  }
});

onMounted(() => {
  store.dispatch("Org/fetchGrantedOrgsList");
  initialData(roles.value);
  window.addEventListener("click", (e: any) => {
    if (!document.getElementById("clickbox-role")?.contains(e.target)) {
      (backgroundRef as any).animation &&
        (backgroundRef as any).animation.reloadToggle();
    }
  });

  EventEmitter.on(EmitterEvents.ROLE_CREATED, async (value: any) => {
    try {
      const members = await getMemberOfRoles(value.member.roleId);
      memberOfRoles.value = {
        ...memberOfRoles.value,
        [`${value.member.roleId}`]: members.data.data.members,
      };
    } catch (error: any) {
      if (error?.data?.message) {
        onShowToast(error.data.message);
      } else if (error?.data?.error?.type) {
        onShowToast(error?.data?.error?.message);
      }

      memberOfRoles.value = {};
    }

    showSuccessToast(
      `"${value.roleTitle}" ${getUiText(
        "app-settings-team-roles-add-role-modal-success-toast-1",
      )}`,
    ); // Role created successfully
  });
});

const showDeleteModal = async (roleId: string) => {
  showModalDeleteRole.value = true;
  selectedRole.value = roleId;
};

onBeforeUnmount(() => {
  window.removeEventListener("click", () => {});
});

const initialData = async (rolesData: any[]) => {
  if (rolesData.length > 0) await fetMemberOfRole(rolesData);
};

watch(roles, async (newValue: any, oldValue: any) => {
  if (!oldValue || oldValue !== newValue) {
    initialData(newValue);
  }
});
const fetMemberOfRole = async (rolesData: any[] = []) => {
  try {
    loading.value = true;
    let promise = [] as any[];
    rolesData.forEach((role: any) =>
      promise.push(getMemberOfRoles(role.roleId)),
    );

    const res = await Promise.all(promise);
    const arrayDataRes: IOrgMemberRes[] = res.map((obj) => obj.data.data);

    const objectDataRes = arrayDataRes.reduce((result, obj) => {
      result[obj.roleId] = obj.members;
      return result;
    }, {});
    memberOfRoles.value = objectDataRes;
  } catch (error: any) {
    if (error?.data?.message) {
      onShowToast(error.data.message);
    } else if (error?.data?.error?.type) {
      onShowToast(error?.data?.error?.message);
    }

    memberOfRoles.value = {};
  } finally {
    loading.value = false;
  }
};

const onShowToast = (messageError: string) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message: messageError,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const showSuccessToast = (message: string) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.SUCCESS,
    message: message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const handleAddUserToRole = ($event) => {
  if ($event && $event.users && $event.users.length)
    updateUserAddToRole($event.users);
};

const updateUserAddToRole = (users) => {
  memberOfRoles.value[`${selectedRole.value}`] = uniqBy(
    memberOfRoles.value[`${selectedRole.value}`].concat(users),
    "userId",
  );
};

const addRole = () => {
  showModalAddRole.value = true;
};

const showModalAddUserToRole = (role: any) => {
  selectedRole.value = role["roleId"];
  selectedRoleName.value = role["roleName"];
  showModalAddUser.value = true;
};

const goToManageRole = (roleId) => {
  router.push({ path: `/settings/team/roles/manage/${roleId}`, replace: true });
};

const onDeleteRole = async () => {
  showModalDeleteRole.value = false;
  try {
    const res = await deleteRole(selectedRole.value);
    if (res && res.data) {
      store.dispatch("Org/setOrgRoles", res.data.data);
      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message: getComponentUiText(
          "app-settings-team-roles-manage-role-toast-message-delete-role-success-1",
        ),
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.deleteRole);
    }
  }
};
const onPageCompleted = () => {
  if (!loading.value && isLoading.value)
    EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED);
};
watch(loading, onPageCompleted);
</script>

<style lang="scss" scoped>
#appBarLayout {
  overflow-y: hidden;
}

.main {
  background: var(--UI-rule-50, rgba(239, 240, 241, 0.5));
  width: 100%;
  height: 100%;
  position: relative;
  overflow-y: auto;
}

.title-inner {
  font-size: 22px;
  margin-bottom: 0;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
}

.roles-container {
  width: 100%;
  position: relative;
  border-top: 1px solid var(--UI-rule, #eff0f1);

  .custom-info {
    margin-top: 25px;
  }

  .grey-color {
    color: #878787;
  }
}

.content {
  display: flex;

  .table-content {
    min-width: 100%;
  }
}

.current-roles-table {
  min-width: 100%;
}

.list-container {
  .content {
    overflow-x: auto;
    display: flex;
  }

  .card-container {
    min-width: 100%;
    width: fit-content;
  }

  .button-add {
    width: fit-content;
    height: 36px;
    font-size: 13px;
    font-weight: 500;
    line-height: 19.5px;
    padding: 8px 20px;
    border: none;
    border-radius: 100px;
    color: #ffffff;
    background-color: #387dff;
  }
}

.list-container {
  border-radius: 6px;
  border: 1px solid var(--UI-rule, #eff0f1);
  background: var(--UI-white, #fff);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}

.list-container .sub-header {
  height: 67px;
  border-bottom: 1px solid #eff0f1;
}

.actions-button-container {
  margin-top: 40px;
  margin-bottom: 40px;
}

@media (max-width: 1280px) {
  .roles-container {
    max-width: unset;
    min-width: unset;
    flex-direction: column-reverse;
  }

  .actions-button-container {
    margin: 40px 0 30px 0;
  }
}

@media (max-width: 768px) {
  .roles-container {
    max-width: unset;
    min-width: unset;
    flex-direction: column-reverse;
  }

  .actions-button-container {
    margin: 40px 0 30px 0;
  }
}
</style>
